import { Component, Input } from "@angular/core";
import { FormTemplateQuestion } from "src/app/main/model/forms/form-template-question.model";
import { FormCompletionService } from "src/app/main/services/form-completion/form-completion.service";

const SLIDER_INTERACTION_KEYS = new Set([
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "End",
  "Home",
  "PageDown",
  "PageUp",
]);

@Component({
  template: "",
  standalone: false,
})
export class FormCompletionBaseComponent {
  @Input() class: string;

  constructor(private formCompletionService: FormCompletionService) {}

  // helpers
  public get service() {
    return this.formCompletionService;
  }

  /**
   * Records a value only after a respondent explicitly interacts with a question control.
   * @param question Question whose answer is being recorded.
   * @param value Value deliberately selected or confirmed by the respondent.
   */
  protected recordExplicitAnswer(question: FormTemplateQuestion, value: unknown): void {
    const control = this.service.formGroup.controls[question.getName()];
    control.setValue(value);
    control.markAsDirty();
    control.markAsTouched();
    control.updateValueAndValidity();
  }

  /**
   * Identifies keyboard actions that deliberately operate a slider; focus navigation is excluded.
   * @param key KeyboardEvent key value.
   * @returns Whether the key represents a slider interaction.
   */
  protected isSliderInteractionKey(key: string): boolean {
    return SLIDER_INTERACTION_KEYS.has(key);
  }
}
